<template>
  <div>
    <div v-if="job.appointments" class="d-flex flex-column">
      <div class="appointment-tab-header mb-3">
        <h3 class="mb-0 page-header-2">
          Appointments ({{ job.appointments.length }})
        </h3>
        <Button
          text="Add Appointment"
          @click="
            withJobWarnings({
              action: toggleAddModal,
              record: job,
              context: 'add-appointment'
            })
          "
        />
      </div>
      <div class="appointments-container">
        <Appointment
          v-for="appointment in jobAppointments"
          :key="appointment.id"
          :appointment="appointment"
          :customer="job.customer"
          class="appointment-card"
          data-cy="appointment-details"
        />
      </div>
      <div class="mt-3">
        <Notes
          v-if="job.id"
          ref="notes"
          :commentable-id="job.id"
          commentable-type="Job"
          @refresh-job="fetchJob({ jobId: job.id })"
        />
      </div>
    </div>
    <schedule-appointment-modal
      v-if="addModal"
      :job="job"
      @hide-modal="toggleAddModal"
    ></schedule-appointment-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { EventBus } from "@/lib/event_bus.js";
import { getQueryVariables } from "@/lib/url.js";

import Button from "@/components/Button.vue";
import Notes from "@/Comments/Comments.vue";
import Appointment from "@/Job/AppointmentCard/Appointment.vue";
import { jobWarnings } from "@/mixins/jobWarnings";
import ScheduleAppointmentModal from "@/ScheduleModal/ScheduleAppointmentModal.vue";

export default {
  components: {
    Appointment,
    Notes,
    Button,
    ScheduleAppointmentModal
  },
  mixins: [jobWarnings],
  data() {
    return {
      addModal: false
    };
  },
  computed: {
    ...mapState({
      job: "job",
      jobAppointments({ job }) {
        return job.appointments.map((appointment) => ({
          address: job.address,
          customer: job.customer,
          ...appointment
        }));
      }
    }),
    ...mapGetters(["featureEnabledForTenant"])
  },
  mounted() {
    const { create_appt } = getQueryVariables();
    this.addModal = create_appt === "true" ? true : false;
    EventBus.$on("refresh-job-notes", this.refreshJobNotes);
  },
  beforeUnmount() {
    EventBus.$off("refresh-job-notes", this.refreshJobNotes);
  },
  methods: {
    ...mapActions(["fetchJob"]),
    toggleAddModal() {
      this.addModal = !this.addModal;
      if (!this.addModal) {
        // refresh job notes after adding appointment
        this.refreshJobNotes();
      }
    },
    refreshJobNotes() {
      EventBus.$emit("refresh-comments");
    }
  }
};
</script>

<style scoped>
.appointment-row > div {
  margin-right: 2rem;
}

.appointments-container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.appointment-tab-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
</style>
